const togglers = Array.from(document.querySelectorAll(".js-togglenav"))
const body = document.querySelector("body")
togglers.forEach((element) => {
	element.addEventListener("click", () => {
		body.classList.toggle("mobile-nav-active")
	})
})